import votesSlice, {
  VotesSlice as _VotesSlice,
  createVote as _createVote,
  deleteVote as _deleteVote,
  endVote as _endVote,
  endAllVotes as _endAllVotes,
  editVote as _editVote,
  startVote as _startVote
} from './votesSlice'

export type VotesSlice = _VotesSlice
export const createVote = _createVote
export const deleteVote = _deleteVote
export const editVote = _editVote
export const startVote = _startVote
export const endVote = _endVote
export const endAllVotes = _endAllVotes
export default votesSlice
export const votesReducer = votesSlice.reducer
export const votesActions = votesSlice.actions
